
import { Component, Prop, Vue, Ref } from 'nuxt-property-decorator';
import MultiSelect from 'vue-multiselect';
import Modal from '../modals/Modal.vue';
import { InputText, InputCheckbox } from '../../components/design-system/input';
import FeaturedIcon from '../design-system/molecules/FeaturedIcon.vue';
import { AuthorUnderEdition } from './Authors.vue';

@Component({
  $_veeValidate: {
    validator: 'new',
  },
  components: { Modal, InputText, InputCheckbox, MultiSelect, FeaturedIcon },
})
export default class AuthorModal extends Vue {
  @Prop({ required: true }) author!: AuthorUnderEdition;
  @Prop({ default: [] }) existingAffiliations!: string[];
  @Prop({ type: Boolean, default: false }) isWaiting!: boolean;
  @Ref() modal?: Modal;

  model: AuthorUnderEdition | null = null;
  affiliations: string[] = [];

  mounted() {
    for (const existingAff of this.existingAffiliations) {
      if (!this.affiliations.includes(existingAff)) {
        this.affiliations.push(existingAff);
      }
    }
  }

  get hasAffiliationsError() {
    return !!this.errors.first('affiliations');
  }

  public async save() {
    if (!(await this.$validator.validateAll())) return;
    this.$emit('save', this.model);
  }

  public modalCloseHandler() {
    this.$emit('close');
  }

  public addAffiliation(item) {
    this.affiliations.push(item);
    this.model?.affiliations.push(item);
  }

  public triggerVisibility(targetElement?: HTMLButtonElement | EventTarget | null) {
    this.model = Object.assign({}, this.author);
    this.modal?.triggerVisibility(targetElement);

    // show the email validation error if the author has an id but no email (for legacy submissions)
    if (this.author.firstName && !this.author.email) {
      this.$nextTick(() => {
        if (this.$validator.fields.find({ name: 'email' })) this.$validator.validate('email');
      });
    }
  }
}
